<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__crmcallback}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
         <el-form-item>
          <el-input v-model="dataForm.name" placeholder="客户姓名" clearable></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-input v-model="dataForm.mobile" placeholder="手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.channelId" filterable clearable placeholder="请选择渠道">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.callStartDate"
                  type="date"
                  placeholder="回访开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.callEndDate"
                  type="date"
                  placeholder="回访结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.entryStartDate"
                  type="date"
                  placeholder="录入开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.entryEndDate"
                  type="date"
                  placeholder="录入结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-select v-model="dataForm.companyId" filterable  clearable placeholder="所属公司">
            <el-option
                    v-for="item in companys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-select v-model="dataForm.callType" filterable  clearable placeholder="回访类型">
            <el-option
                    v-for="item in callbackList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:crmcallback:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:crmcallback:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerId" label="用户id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName" label="用户" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mobile" label="手机号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channelId" label="渠道名称" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
           {{ getDictLabel(scope.row.channelId) }}
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="公司" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="callType" label="回访类型" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.callType == 0" >(0星)无建联</span>
            <span v-if="scope.row.callType == 1">(1星)已建联，资质差，三无人员</span>
            <span v-if="scope.row.callType == 2" >(2星)有需求，无抵押物，需要养护</span>
            <span v-if="scope.row.callType == 3" >(3星)有需求，有可贷点，能进店客户</span>
            <span v-if="scope.row.callType == 4">(4星)有需求，有抵押物，有公积金，能签约客户</span>
            <span v-if="scope.row.callType == 5" >(5星)已签约</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="推送内容" header-align="center" align="center" show-overflow-tooltip width="300"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isPush" label="是否已推送" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isPush == 1"  size="small">是</el-tag>
            <el-tag v-if="scope.row.isPush == 0" type="danger" size="small">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pushCode" label="推送返回状态码" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushMsg" label="推送返回信息" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushDate" label="推送时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="creator" label="创建人" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="updateBy" label="更新人" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="status" label="状态" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1"  size="small">有效</el-tag>
            <el-tag v-if="scope.row.status == 0" type="danger" size="small">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="info" size="small">未回访</el-tag>
            <el-tag v-if="scope.row.type == 1"  size="small">有效</el-tag>
            <el-tag v-if="scope.row.type == 2" type="danger" size="small">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="channelId" label="渠道ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:crmcallback:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:crmcallback:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './crmcallback-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/crmcallback/page',
        getDataListIsPage: true,
        exportURL: '/sys/crmcallback/export',
        deleteURL: '/sys/crmcallback',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      companys:[],
      callTypes:[],
      channels:[],
      callbackList:[
        {value: '0', label: '(0星)无建联'},
        {value: '1', label: '(1星)已建联，资质差，三无人员'},
        {value: '2', label: '(2星)有需求，无抵押物，需要养护'},
        {value: '3', label: '(3星)有需求，有可贷点，能进店客户'},
        {value: '4', label: '(4星)有需求，有抵押物，有公积金，能签约客户'},
        {value: '5', label: '(5星)已签约'}
      ],
    }
  },
  components: {
    AddOrUpdate
  },
   created () {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.getCompanysOptions();
      this.getCallTypeOptions()
    }
    this.getchannelsOptions();
  },
  methods: { 
     getDictLabel(value) {
      const dictItem = this.channels.find(item => item.value == value);
      return dictItem ? dictItem.label : ''; 
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.channels.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.companys.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    async getCallTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=return-type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.callTypes = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                    this.callTypes.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  },
}
</script>
